
const aboutneo25 = {
    "About NeoGrowth Mar’25": [
        {
          question: "What are the important details of the Bond offering?",
          answer:"Coupon Rate: 11.25% p.a <br />" + 
          "Coupon Frequency: Quarterly <br />" + 
          "Principal Repayment: 28th Oct’ 24 <br />" + 
          "ISIN: INE814O07477<br />" + 
          "Debenture Trustee: Catalyst Trusteeship Ltd. <br />" + 
          "Credit Rating: ‘BBB/ Stable Outlook by ICRA <br />" + 
          "Listing Details: Bombay Stock Exchange (BSE) <br />"  +
          "Coupon : Fixed <br/>" +
          "Original Mode of Issue: Private Placement <br/>" +
          "Date of Issue: 27th Sep, 2023 <br/>"      
        },
        {
          question: "What is the Security of the Bond?",
          answer: "The Bond is secured by way of a first ranking, exclusive and continuing charge on identified loan receivables for 1.1x the outstanding amount of the Bond (including Interest accrued)."
        },
        {
          question: "What are the important covenants that the Issuer has to adhere to?",
          answer: "a. The Capital Adequacy Ratio (Tier 1 and Tier 2 capital) shall not fall below 20% <br />" + 
           "b. The AUM of the issuer should not fall below ₹ 1,700 Crs. <br />" + 
           "c. Issuer has to maintain minimum external rating of BBB during the tenure. <br />" + 
           "d. Total Debt to Total Networth should not exceed 4 times. <br />"+
           "e. Mr. Piyush Khaitan (Founder & Chairman) would continue to be on Board of the Issuer. <br />"+
           "d. The profit before tax should be positive. <br />"
  
        },
        {
          question: "Can I liquidate the bond before maturity?",
          answer: "Yes, you can liquidate the bond before maturity through our anytime liquidation feature. However,  the liquidation will happen at a discount of 2% to the value of the bond."
        },
        {
          question: "How is the Yield to Maturity (YTM) is calculated?",
          answer: "The Yield to Maturity is calculated using the XIRR formula present in Microsoft Excel or such other spreadsheets. The cash flow is populated in the spreadsheet along with the dates and the XIRR formula is then applied to get the YTM."
        }
      ],
  }
  
  export default aboutneo25;